<template>
  <header>
    <img src="static/img/logo1.png" class="logo">
    <p>淘金区域代理</p>
    <ul>
      <li :class="{'active':addActive%2 == 1}"><a href="/reginalAgent/runnability">运行情况</a></li>
      <li :class="{'active':addActive%2 != 1}"><a href="/reginalAgent/myService">我的客服</a></li>
    </ul>
    <div class="logOut" @click="logOut">登出</div>
  </header>
</template>
<script>
export default {
  data(){
    return {
     
    }
  },
  props: ['addActive'],
  methods: {
    logOut: function() {
      this.$http.post(API_ROOT.system + "/agency/logOut").then(response=> {
        var result = response.data
        if(result.success) {
          this.delCookie('reginal_agency_token')
          this.$router.push({name: 'login'});
        }else {
          this.$message({
            message: result.msg,
            type: 'success',
            center: true,
            duration: 1000
          })
        }
      },response=> {
        this.$message({
          message: '网络繁忙，请稍后重试！',
          type: 'error',
          center: true,
          duration: 1000
        })
      })
    },
    delCookie: function(name){
      var exp = new Date();
      exp.setTime(exp.getTime() - 1);
      var cval = this.getCookie(name);
      if(cval!=null)
      window.document.cookie= name + "="+cval+";expires="+exp.toGMTString();
    },
    //读取cookies
    getCookie:function(name){
      var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
      if(arr = window.document.cookie.match(reg))
          return (arr[2]);
      else
          return null;
    }
  }
}
</script>

<style lang="less" scoped>
  header {
    height: 80px;
    width: 100%;
    background: #30313e;
    overflow: hidden;
    >.logo {
      width: 60px;
      height: 60px;
      margin-left: 20px;
      margin-top: 10px;
      float: left;
    }
    >p {
      height: 30px;
      font-size: 20px;
      color: #fff;
      line-height: 20px;
      margin-left: 10px;
      margin-top: 30px;
      float: left;
    }
    >ul {
      margin-left: 200px;
      height: 40px;
      font-size: 18px;
      margin-top: 25px;
      float: left;
      overflow: hidden;
      >li {
        float: left;
        color: #fff;
        height: 40px;
        width: 112px;
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        position: relative;
        margin-left: 5px;
        >a {
          width: 100%;
          height: 100%;
          display: block;
          color: #fff;
        } 
      }
      >li:hover {
        color: #20a0ff;
        >a {
          color: #20a0ff;
        } 
      }
      >li:hover:after{
        content: '';
        height: 2px;
        width: 112px;
        background: #20a0ff;
        display: block;
        position: absolute;
        left: 0;
        top:35px;
        >a {
          color: #20a0ff;
        } 
      }
      >.active {
        color: #20a0ff;
        >a {
          color: #20a0ff;
        } 
      }
      >.active:after{
        content: "";
        height: 2px;
        width: 112px;
        background: #20a0ff;
        display: block;
        position: absolute;
        left: 0;
        top:35px;
        >a {
          color: #20a0ff;
        } 
      }
    }
    >.logOut {
      font-size: 18px;
      float: right;
      margin-top: 25px;
      height: 30px;
      line-height: 35px;
      margin-right: 30px;
      cursor: pointer;
      color: #ccc;
    }
    >.logOut:hover {
      border-bottom: 1px solid #ccc;
    }
  }
</style>



// WEBPACK FOOTER //
// header.vue?1dcde311